import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  initialize,
  login,
  NewPasswordRequiredCode,
  useIntlError,
} from '@beeriot/api-client';
import { LoginForm, LoginFormFields } from '../../auth';
import { RootAuthPageStack } from './RootAuthPageStack';
import { useMutation } from 'react-query';

export function LoginPage() {
  const [error, setError] = useState<string | undefined>();
  const navigate = useNavigate();
  const intlError = useIntlError();
  const loginMutation = useMutation(async (data: LoginFormFields) => {
    try {
      const userInfo = await login(data.email, data.password);
      await initialize(userInfo);
      navigate('/');
    } catch (loginErr) {
      if (loginErr === NewPasswordRequiredCode) {
        navigate('/setup');
      } else if (typeof loginErr === 'string') {
        setError(intlError(loginErr));
      } else {
        setError(intlError(''));
      }
    }
  });

  return (
    <RootAuthPageStack>
      <LoginForm error={error} mutation={loginMutation} />
    </RootAuthPageStack>
  );
}
